import Api from "../Utils/Axios";

// export const GetGuideList = async (data) => {
//   const response = await Api.get("guideProduct/list", { params: data });
//   return response.data;
// };

export const GetGuideList = async (searchValue = "") => {
  const response = await Api.get(`guideProduct/list/?search=${searchValue}`);
  return response.data;
};
export const CreateGuide = async (data) => {
  const response = await Api.post("guideProduct/", data);
  return response.data;
};

export const DeleteGuide = async (data) => {
  const response = await Api.delete(`guideProduct/${data}`);
  return response.data;
};

export const GetSingleGuide = async ({ id }) => {
  const response = await Api.get(`guideProduct/${id}`);
  return response.data;
};

export const UpdateGuide = async (data) => {
  const response = await Api.put("guideProduct/", data);
  return response.data;
};

export const AddImages = async (data) => {
  const response = await Api.post("general/uploadFiles/?returnUrls=true", data);
  return response.data;
};

export const DragAndDropGuide = async (data) => {
  const response = await Api.post("guideProduct/changeOrder", data);
  return response.data;
};
